import {defineRule} from "vee-validate";
import {email} from '@vee-validate/rules';
import {i18n} from "@/i18n";

defineRule('email', (value) => {
    return email(value) || i18n.global.t('Validation.Email');
});
